import { NetworkManager, API } from "../../../../../Network/core";

export const useLogoutModel = () => {
  const adminLogout = async () => {
    const instance = await NetworkManager(API.AUTH.LOGOUT);
    const response = await instance.request();
    return response;
  };

  const userLogout = async () => {
    const instance = await NetworkManager(API.USER.LOGOUT);
    const response = await instance.request();
    return response;
  };

  return {
    adminLogout,
    userLogout,
  };
};
